<template>
  <coverageAndThomaticReport type="province" label="provinces_report" />
</template>
<script>
import coverageAndThomaticReport from "./coverageAndThomaticReport";
export default {
  components: { coverageAndThomaticReport }
};
</script>
